<template>
  <div>
    <el-row>
      <el-col :span="12">
        <label>{{$t('Revisores')}}</label><br>
        <el-input-number
          v-model="step.totalPeople"
          @change="setPeople"
          :min="1"
          size="medium">
        </el-input-number>
      </el-col>
      <el-col :span="12">
        <label>{{$t('Mínimo aprobaciones')}}</label><br>
        <el-input-number
          v-model="step.minToApprove"
          size="medium"
          :min="1"
          :max="step.totalPeople">
        </el-input-number>
      </el-col>
    </el-row>

    <div
      v-for="(profile, index) in step.peopleProfile"
      v-bind:key="index"
      class="people-container">
      <el-row class="person">
        <el-col :span="5" class="mt-1">
          Revisor {{ index + 1 }}
        </el-col>
        <el-col :span="17">
          <el-select v-model="step.peopleProfile[index]"
            clearable
            :placeholder="$t('Seleccione perfil revisor')"
            class="profile-select"
            size="medium">
            <el-option
              v-for="(value, key) in bhpProfiles"
              :key="key"
              :label="value"
              :value="key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button
            v-if="step.totalPeople > 1"
            type="danger"
            icon="el-icon-close"
            size="small"
            style="float: right"
            @click="deleteProfile(index)">
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkflowCreateStep',
  props: [
    'step',
  ],
  data() {
    return {
      bhpProfiles: {
        hse: 'Asesor SSO',
        health: this.$t('Especialista de Salud'),
        safety: this.$t('Especialista de Seguridad'),
        environment: this.$t('Especialista de Medioambiente'),
        contractor_hse: this.$t('Asesor SSO Contratista'),
        owner: this.$t('Dueño de Contrato'),
        contract_owner: this.$t('Dueño de Contrato'),
        risk: this.$t('Especialista de Riesgo'),
        administrator: this.$t('Administrador de Contrato'),
        contractor_coordinator: this.$t('Coordinador Contratista'),
        coordinator: this.$t('Coordinador'),
        manager: this.$t('Gerente de Área'),
        super: this.$t('Superintendente de Área'),
        general_manager: this.$t('Gerente General'),
      },
    };
  },
  methods: {
    setPeople(value) {
      if (this.step.totalPeople > this.step.peopleProfile.length) {
        this.step.people.push(null);
        this.step.peopleProfile.push(null);
      } else if (this.step.totalPeople < this.step.peopleProfile.length) {
        this.step.people.pop();
        this.step.peopleProfile.pop();
      }
    },
    deleteProfile(index) {
      if (this.step.totalPeople - 1 > 0) {
        this.step.people.splice(index, 1);
        this.step.peopleProfile.splice(index, 1);
        this.step.totalPeople -= 1;
      }
    },
  },
};
</script>


<style scoped>
  .people-container {
    margin-top: 10px;
  }
  .person {
    border-top: solid 1px #E4DCCF;
    padding-top: 8px;
  }
  .profile-select {
    width: 99%;
  }
  .mt-1{
    margin-top: 5px;
  }
</style>
